export async function generateShareImage(amount: number, meals: number, settings?: Record<string, string>): Promise<string> {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Canvas 2D context not available');
  }

  const size = 1080;
  canvas.width = size;
  canvas.height = size;

  const bgUrl = 'https://s2c-donation-api.jimsbond007.workers.dev/api/public/media/general/1777721614786_cxefledi.jpg';
  const logoUrl = 'https://s2c-donation-api.jimsbond007.workers.dev/api/public/media/general/1777627051714_z34l4y1y.png';
  const qrUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://donate.s2c.org.hk/';

  // Load images
  const loadImage = (src: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });

  const c = ctx!;
  function drawTextWithStroke(
    text: string,
    x: number,
    y: number,
    font: string,
    fillStyle: string = '#ffffff',
    strokeStyle: string = '#000000',
    lineWidth: number = 4
  ) {
    c.font = font;
    c.textAlign = 'center';
    c.textBaseline = 'middle';
    c.lineWidth = lineWidth;
    c.strokeStyle = strokeStyle;
    c.strokeText(text, x, y);
    c.fillStyle = fillStyle;
    c.fillText(text, x, y);
  }

  try {
    const [bgImg, logoImg, qrImg] = await Promise.all([
      loadImage(bgUrl),
      loadImage(logoUrl),
      loadImage(qrUrl),
    ]);

    // Draw background
    ctx.drawImage(bgImg, 0, 0, size, size);

    // No overlay - text stroke provides readability

    // Start text from 1/3 height
    const textStartY = size / 3 + 80;

    // Slogan
    drawTextWithStroke(
      settings?.shareSlogan || '一餐飯，改寫兩個人生',
      size / 2,
      textStartY,
      'bold 64px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif'
    );

    // Divider
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(size / 2 - 120, textStartY + 60);
    ctx.lineTo(size / 2 + 120, textStartY + 60);
    ctx.stroke();

    // Amount
    drawTextWithStroke(
      `HK$${amount.toLocaleString()}`,
      size / 2,
      textStartY + 180,
      'bold 120px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif'
    );

    // Meals
    drawTextWithStroke(
      `= ${meals}份飯餐`,
      size / 2,
      textStartY + 300,
      '48px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif'
    );

    // Sub impact (bold + black stroke)
    drawTextWithStroke(
      'SEN青年獲職訓 · 基層人士獲飯餐',
      size / 2,
      textStartY + 370,
      'bold 37px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif',
      '#ffffff',
      '#000000',
      2
    );

    // Brand
    drawTextWithStroke(
      settings?.orgName || '好餸傳愛',
      size / 2,
      textStartY + 460,
      'bold 56px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif'
    );

    drawTextWithStroke(
      '社區飯堂 · 職訓平台',
      size / 2,
      textStartY + 520,
      'bold 35px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif',
      '#ffffff',
      '#000000',
      2
    );

    // Logo at bottom-left (2x bigger: 300px)
    const logoWidth = 300;
    const logoHeight = logoImg.height * (logoWidth / logoImg.width);
    c.drawImage(logoImg, 40, size - logoHeight - 20, logoWidth, logoHeight);

    // QR code at bottom-right
    const qrSize = 180;
    c.drawImage(qrImg, size - qrSize - 40, size - qrSize - 40, qrSize, qrSize);

    // QR label below QR code
    drawTextWithStroke(
      '掃碼捐款',
      size - qrSize / 2 - 40,
      size - 22,
      'bold 24px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif'
    );

    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('Failed to load share images:', err);
    // Fallback: generate text-only version
    c.fillStyle = settings?.sitePrimaryColor || '#E07B39';
    c.fillRect(0, 0, size, size);

    const textStartY = size / 3 + 80;

    drawTextWithStroke('一餐飯，改寫兩個人生', size / 2, textStartY, 'bold 72px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif');
    drawTextWithStroke(`HK$${amount.toLocaleString()}`, size / 2, textStartY + 200, 'bold 96px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif');
    drawTextWithStroke(`= ${meals}份飯餐`, size / 2, textStartY + 320, '48px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif');
    drawTextWithStroke('https://donate.s2c.org.hk/', size / 2, textStartY + 500, 'bold 32px system-ui, -apple-system, "Segoe UI", "Noto Sans SC", sans-serif');

    return canvas.toDataURL('image/png');
  }
}
